module.exports = __webpack_public_path__ + "img/defaultImage.0db23d69.png";